import React from 'react';
import Mainmastet from '../masterpage/Mainmastet';
import Warehouse from '../resorcesfiles/ideak/asset.png'; // Replace with the appropriate image path

const ProjectAsset = () => {
  return (
    <Mainmastet content={<>
    
    <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }}>
      <h1>RFID Asset Tracking Management</h1>
      <p>
        RFID asset tracking enables you to advance your business to a new level.
      </p>
      <h2>RFID for Business</h2>
      <p>
        Using RFID tags to track and manage assets can greatly improve asset tracking activities by automating processes, improving data accuracy, and better securing. RFID can fully automate this process and make it easier for staff to locate and identify assets, as well as track when they are moved or removed for maintenance or disposal.
      </p>
      <h2>Material Identification</h2>
      <ul>
        <li>Real-time management</li>
        <li>High speed read RFID</li>
      </ul>
      <h2>Typical Applications</h2>
      <ul>
        <li>IT asset tracking</li>
        <li>Office equipment tracking</li>
        <li>Tracking of furniture, lighting, etc.</li>
        <li>Consigned asset tracking such as fridges, stands, promotional materials, displays</li>
        <li>Manufacturing equipment and tools tracking</li>
        <li>Hospital asset tracking such as critical machinery, beds, dispensers, etc.</li>
        <li>Hotel equipment tracking</li>
        <li>Rental equipment tracking</li>
      </ul>
      <p>
        RFID can fully automate this process and make it easier for staff to locate and identify assets, as well as track when they are moved or removed for maintenance or disposal.
      </p>
      <h2>Components of an RFID system</h2>
      <ul>
        <li>Passive RFID tags that are electronically programmed with unique information</li>
        <li>RFID label printing service</li>
        <li>Mobile RFID reader</li>
        <li>Fixed Reader</li>
      </ul>


      <div style={{justifyContent:'center',alignItems:"center",display:'flex',flexDirection:'column'}}>
      <img src={Warehouse} alt="RFID Asset Management" style={{ maxWidth: '100%', height: 'auto' }} />

      </div>
      <div style={{height:'50px'}}></div>

    </div>


    </>}/>
  );
};

export default ProjectAsset;
